var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3292_11626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 14.862L11.8253 10.8827C12.9098 9.5564 13.4429 7.86406 13.3146 6.15571C13.1862 4.44735 12.4061 2.85369 11.1357 1.70435C9.86531 0.555007 8.20174 -0.0620722 6.4891 -0.019251C4.77647 0.0235702 3.14581 0.723015 1.93442 1.93441C0.723023 3.1458 0.0235778 4.77646 -0.0192434 6.48909C-0.0620646 8.20173 0.555014 9.8653 1.70435 11.1357C2.85369 12.4061 4.44736 13.1862 6.15571 13.3146C7.86407 13.4429 9.5564 12.9097 10.8827 11.8253L14.862 15.8047C14.9877 15.9261 15.1561 15.9933 15.3309 15.9918C15.5057 15.9903 15.6729 15.9202 15.7966 15.7965C15.9202 15.6729 15.9903 15.5057 15.9918 15.3309C15.9933 15.1561 15.9261 14.9877 15.8047 14.862ZM6.66667 12C5.61184 12 4.58069 11.6872 3.70363 11.1012C2.82657 10.5151 2.14298 9.68218 1.73932 8.70764C1.33565 7.73311 1.23003 6.66075 1.43582 5.62618C1.64161 4.59162 2.14956 3.64131 2.89544 2.89543C3.64132 2.14955 4.59163 1.6416 5.62619 1.43581C6.66076 1.23002 7.73311 1.33564 8.70765 1.73931C9.68219 2.14298 10.5151 2.82656 11.1012 3.70362C11.6872 4.58069 12 5.61183 12 6.66667C11.9984 8.08067 11.436 9.4363 10.4362 10.4361C9.43631 11.436 8.08067 11.9984 6.66667 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3292_11626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ee12c69ce9c97f9eba18d090f5a6bad1.svg";
export { ForwardRef as ReactComponent };